module.exports = __webpack_public_path__ + "img/47.0cd0d897.svg";